import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Servicespartner(props) {
  return (
    <div className="tekrevol_gray_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Solutions">
              <h2>Ensure Innovation By Going Serverless</h2>
            </div>
            <h5 className="strong">
              Why choose Us for your Serverless Computing needs?
            </h5>
            <p>
              With a skilled team that provides serverless computing services,
              we deliver customized solutions perfectly matched to your business
              needs. Our dedication to cost efficiency guarantees that your
              serverless infrastructure is finely tuned to reduce expenses while
              boosting performance and scalability.
            </p>
            <p>
              With a comprehensive set of serverless technologies, we ensure
              that your organization reaps maximum benefits from going
              serverless. Our serverless computing radically simplifies the
              software delivery, management, and operational processes.
            </p>
            <p>
              As top serverless computing services providers, we manage
              intricate facets of your infrastructure and free you to focus on
              business expansion and strategic initiatives.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <StaticImage
              src="../../images/services/servless-computing/why_choose.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={651}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Servicespartner;
